import { useEffect, useState } from 'react';
import { Card, Accordion } from 'react-bootstrap';
import {
  AccordionDownArrow,
  AccordionUpArrow,
} from '../../../../img/findcare/FindCareSVG';
import './MessageDetailComponent.scss';
import {
  AttachmentPinSymbolSVG,
  AttachedFileSymbolSVG,
  FileDownloadSymbolSVG,
  ReplySymbolSVG,
  ReplyAllSymbolSVG,
} from 'src/Member/img/NotificationSVG';
import SendMessage from './SendMessage';
import { useSelector } from 'react-redux';
import { formatMessageDateAndTime } from 'src/common/utils';

const MessageDetailComponent = ({
  isComposing,
  setIsComposing,
  replyEnabled,
  setReplyEnabled,
  selectedData = [],
  getSanitizedContent,
  isUpdateAndReminder = false,
  onDownload = (item) => console.log('item to download', item),
  onDownloadAll = (items) => console.log('download all file', items),
  setIsComposed,
  sendNewMessageFormRef,
  sendReplyMessageFormRef,
  mainSelectedTab,
}) => {
  const pageTitle =
    mainSelectedTab === 'messages' ? 'Message' : 'Update/Reminder';
  useEffect(() => {
    console.log('selectedData', selectedData, viewAll);

    setViewAll(false);
  }, [selectedData]);

  const { Sender_Email } = useSelector(
    (state) => state?.app?.appConfigs?.Email_Configration,
  );

  const [activeId, setActiveId] = useState(`message-${0}`);

  const [viewAll, setViewAll] = useState(false);

  const [replySelectData, setReplySelectData] = useState(null);

  const initialVals = 3;
  let showMore = false;

  const toggleActive = (id) => {
    if (activeId === id) {
      setActiveId(null);
    } else {
      setActiveId(id);
    }
  };
  const getMessageTypes = (typeValue) => {
    const messageType = typeValue;
    if (messageType === 'Claims') {
      return <span className="claim-class">{messageType}</span>;
    } else if (messageType === 'Authorizations') {
      return <span className="Authorizations-class">{messageType}</span>;
    } else {
      return <span className="enrollment-class">{messageType}</span>;
    }
  };
  return (
    <div className="message_detail_section">
      {!isComposing && selectedData?.length && (
        <div className="d-flex flex-row justify-content-between bg-white p-3">
          <span className="sr-only" tabIndex={-1} role="contentinfo">
            {pageTitle} Details Section
          </span>
          <div
            className="message_title"
            aria-label={`Subject ${selectedData[0]?.EventTitle}`}
            role="heading"
            aria-level="3"
          >
            {selectedData[0]?.EventTitle}
          </div>
          <div>
            <span className="sr-only">Category</span>
            {getMessageTypes(
              selectedData[0]?.MessagecategorymasterDTOObj?.Categorydesc,
            )}
          </div>
        </div>
      )}
      {(replyEnabled || isComposing) && (
        <div>
          <SendMessage
            isComposing={isComposing}
            setIsComposing={setIsComposing}
            setReplyEnabled={setReplyEnabled}
            setIsComposed={setIsComposed}
            selectedData={replySelectData}
            sendNewMessageFormRef={sendNewMessageFormRef}
            sendReplyMessageFormRef={sendReplyMessageFormRef}
          />
        </div>
      )}
      {!isComposing && selectedData?.length > 0 && (
        <div>
          {pageTitle === 'Message' ? (
            <span className="sr-only" role="contentinfo">
              You have {selectedData?.length} Message
              {selectedData?.length > 1 ? 's' : ''} in this message thread.
            </span>
          ) : (
            ''
          )}
          {selectedData?.map((messageData, index) => (
            <Accordion
              defaultActiveKey={`message-${0}`}
              key={`message-${index}`}
              alwaysOpen
              activeKey={activeId}
            >
              <Card className="mt-3">
                <Accordion.Toggle
                  as={Card.Header}
                  onClick={() => toggleActive(`message-${index}`)}
                  className="panel-toggle bg-white text-left w-100"
                  eventKey={`message-${index}`}
                >
                  <div className="d-flex justify-content-between panel-card-header">
                    <div className="d-flex">
                      <div
                        className="pr-3 pt-2"
                        tabIndex={0}
                        aria-expanded={activeId === `message-${index}`}
                        aria-controls="message-0"
                        aria-label={`Click to ${
                          activeId === `message-${index}`
                            ? 'Collapse'
                            : 'Expand'
                        } ${pageTitle} details tab.`}
                        role="button"
                      >
                        <span className="accordion-arrow">
                          {activeId === `message-${index}` ? (
                            <AccordionDownArrow className="acc-arrow" />
                          ) : (
                            <AccordionUpArrow className="acc-arrow" />
                          )}
                        </span>
                      </div>
                      <div className="" aria-hidden={true}>
                        <span className="message-detail-user-icon-img">
                          {Sender_Email.charAt(0)}
                        </span>
                      </div>
                      <div className="pl-3">
                        <span className="msg_from">To: {Sender_Email}</span>{' '}
                        <br />
                      </div>
                    </div>

                    <div className="d-flex flex-column">
                      {activeId === `message-${index}` &&
                      !isUpdateAndReminder ? (
                        <span className="text-right d-flex justify-content-end align-items-center">
                          <div
                            className="cursor-pointer mr-2"
                            onClick={() => {
                              setReplyEnabled(true);
                              setReplySelectData(messageData);
                              setTimeout(() => {
                                if (sendReplyMessageFormRef?.current) {
                                  sendReplyMessageFormRef?.current?.focus();
                                }
                              }, 300);
                            }}
                            role="button"
                            tabIndex={0}
                            aria-label="Reply, Click to reply to this message."
                          >
                            <ReplySymbolSVG className="message_reply_svg" />
                          </div>
                          <div
                            className="cursor-pointer"
                            onClick={() => {
                              setReplyEnabled(true);
                              setReplySelectData(messageData);
                              setTimeout(() => {
                                if (sendReplyMessageFormRef?.current) {
                                  sendReplyMessageFormRef?.current?.focus();
                                }
                              }, 300);
                            }}
                            role="button"
                            tabIndex={0}
                            aria-label="Reply All, Click to reply all to this message."
                          >
                            <ReplyAllSymbolSVG className="message_reply_svg" />
                          </div>
                        </span>
                      ) : (
                        ''
                      )}

                      <span className="msgreceivedinfo">
                        <span className="sr-only">Received On : </span>
                        {formatMessageDateAndTime(
                          messageData?.ReceivedDateTime,
                        )}
                      </span>
                    </div>
                  </div>
                </Accordion.Toggle>

                <Accordion.Collapse eventKey={`message-${index}`}>
                  <Card.Body className="p-0">
                    {messageData?.attachments === true ? (
                      <div className="d-flex flex-column attachment-div p-3">
                        <div>
                          <AttachmentPinSymbolSVG className="attachmentpinsymbol-svg" />
                          <span className="pl-2 attachment-counts">
                            Attachments (
                            {messageData?.attachmentsDetail?.length})
                          </span>
                          {messageData?.attachmentsDetail?.length > 1 ? (
                            <span
                              className="download_All pl-3 cursor-pointer"
                              onClick={() => onDownloadAll(messageData)}
                              role="button"
                              aria-label="Click to Download All, Attachment Files."
                              tabIndex={0}
                            >
                              <FileDownloadSymbolSVG className="message_file_download_svg" />{' '}
                              Download All
                            </span>
                          ) : (
                            ''
                          )}
                        </div>
                        <div className="msg-attachment-wrapper">
                          {messageData?.attachmentsDetail
                            ?.filter((item, index) => {
                              if (!viewAll && index >= initialVals) {
                                showMore = true;
                                return false;
                              }
                              showMore = false;
                              return true;
                            })
                            .map((item, index) => {
                              return (
                                <div
                                  className="d-flex flex-row attachment-container mt-2"
                                  key={index}
                                >
                                  <div>
                                    <AttachedFileSymbolSVG className="attachment-icon-container" />
                                  </div>
                                  <div className="p-2 file_attachement_name">
                                    {item?.OrigFileName}
                                  </div>
                                  <div
                                    className="cursor-pointer"
                                    onClick={() =>
                                      onDownload({
                                        ...item,
                                        isDmsDoc: messageData?.isDmsDoc,
                                      })
                                    }
                                    tabIndex={0}
                                    role="button"
                                    aria-label={`Click to Download, ${item?.OrigFileName} Attachment Files.`}
                                  >
                                    <FileDownloadSymbolSVG className="message_file_download_svg" />
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                        {showMore && !viewAll && (
                          <span
                            className="View_All_Attachments"
                            onClick={() => setViewAll(true)}
                            tabIndex={0}
                            role="button"
                            aria-label={`Click to view all attachment files.`}
                          >
                            View All Attachments
                          </span>
                        )}
                      </div>
                    ) : (
                      ''
                    )}
                    <div className="p-3">
                      <p
                        className="msg_body"
                        dangerouslySetInnerHTML={{
                          __html: getSanitizedContent(
                            messageData?.EventDesc?.trim(),
                          ),
                        }}
                      />
                    </div>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            </Accordion>
          ))}
        </div>
      )}
    </div>
  );
};

export default MessageDetailComponent;
